import { getLogisticsStatuses, getOutcomeString } from '@features/components/CaseCard/utils';
import { logisticsStatuses, scsStatuses, serviceOutcomeStatuses } from '@features/components/CaseCard/constants';
import { getClinicalRecordByType, isRandomizationScs } from '@/utils/helpers';
import { Case, ClinicalData, ClinicalItemType } from '@/api/apis/case';
import {
  baseCardHeight,
  gapHeight,
  logisticsStatusesHeaderHeight,
  logisticsStatusHeight,
  outcomeHeight,
  scsCaseStatusHeight,
} from '../../constants';

export const getApprovals = (clinicalData: ClinicalData) => {
  const data = getClinicalRecordByType(clinicalData, ClinicalItemType.ServiceConfirmation);
  return {
    surgery: data?.item?.retrievalSurgeon,
    management: data?.item?.ocsSpecialist,
    service: data?.item?.txRepresentative,
  };
};

export const getLogisticStatusesHeight = (caseData: Case) => {
  const { quoteStatus, routeStatus } = getLogisticsStatuses(caseData);
  const statusesGap = 12;
  const hasQuote = Boolean(quoteStatus);
  const hasRoute = Boolean(routeStatus);
  const showLogistics = logisticsStatuses.includes(caseData.status) && (hasQuote || hasRoute);
  if (!showLogistics) return 0;

  let height = logisticsStatusesHeaderHeight + gapHeight;
  if (hasQuote) height += logisticsStatusHeight;
  if (hasRoute) height += logisticsStatusHeight;
  if (hasQuote && hasRoute) height += statusesGap;
  return height;
};

export const getCardHeight = (caseData: Case, extraHeight: number = 0) => {
  const isScs = isRandomizationScs(caseData.randomization);
  const showOutcome = serviceOutcomeStatuses.includes(caseData.status) && !isScs;
  const showScs = scsStatuses.includes(caseData.status) && isScs;

  const logisticStatusesHeight = getLogisticStatusesHeight(caseData);
  const cardOutcomeHeight = showOutcome && getOutcomeString(caseData).length ? outcomeHeight + gapHeight : 0;
  const transplantStatusHeight = showScs ? scsCaseStatusHeight + gapHeight : 0;
  const layoutHeight =
    baseCardHeight + logisticStatusesHeight + cardOutcomeHeight + transplantStatusHeight + extraHeight;

  return layoutHeight;
};
